﻿<script>
    import { nanoid } from "nanoid";

	import TextInput from "./TextInput.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import AddButton from "./buttons/AddButton.svelte";

    import SiblingDetail from "../models/SiblingDetail";

    export let id = `siblingDetails_${nanoid(4)}`;
    export let disabled = null;
    export let required = null;
    export let siblingDetails = [];
    export let claimDetail = null;
    export let useDeceasedLabels = false;
    export let label = "";

    const addNewRow = () => {
        siblingDetails = [...siblingDetails, new SiblingDetail()];
    }

    const deleteRow = (index) => {
        if (siblingDetails.length <= 1) return;

        siblingDetails.splice(index, 1);
        siblingDetails = [...siblingDetails];
    }

    if (siblingDetails == null){
        addNewRow();
    }

    if (siblingDetails){
        while (siblingDetails.length < 2) {
            addNewRow();
        }
    }
</script>

<div class="shadowed-box mt-3">
    <FormRow>
        <FormColumn>
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label>
                {label}
            </label>
        </FormColumn>
    </FormRow>


    
        <FormRow>
	        <FormColumn cols="4">
                {#if !useDeceasedLabels}
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label>Your mother's name</label>
                {:else}
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label>What was the deceased person's mother's name</label>
                    <div class="sublabel">(if known)</div>
                {/if}
	        </FormColumn>
            <FormColumn cols="4">
                {#if !useDeceasedLabels}
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label>Your father's name</label>
                {:else}
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label>What was the deceased person's father's name </label>
                    <div class="sublabel">(if known)</div>
                {/if}
	        </FormColumn>
            <FormColumn cols="4">
                {#if !useDeceasedLabels}
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label>The names of your brothers and sisters</label>
                    <div class="sublabel">(if you have any)</div>
                {:else}
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label>What are the names of the brothers and sisters of the deceased person</label>
                    <div class="sublabel">(if they had any and if known)</div>
                {/if}
	        </FormColumn>
        </FormRow>

    {#each siblingDetails as detail, i (detail)}

        {#if i===0}
        <FormRow>
	        <FormColumn cols="4">
                <TextInput {required} {disabled} bind:value="{claimDetail.mothersName}" id="{id}_mother_{i}"/>
	        </FormColumn>
            <FormColumn cols="4">
                <TextInput {required} {disabled} bind:value="{claimDetail.fathersName}" id="{id}_father_{i}"/>
	        </FormColumn>
            <FormColumn cols="3">
                <TextInput {required} {disabled} bind:value="{detail.siblingsName}" id="{id}_sibling_{i}"/>
	        </FormColumn>
            <FormColumn cols="1" class="last mt-0 d-flex align-items-center">
            </FormColumn>
        </FormRow>
        {/if}
        {#if i>0}
        <FormRow>
	        <FormColumn cols="4">
	        </FormColumn>
            <FormColumn cols="4">
	        </FormColumn>
            <FormColumn cols="3">
                <TextInput {required} {disabled} bind:value="{detail.siblingsName}" id="{id}_sibling_{i}"/>
	        </FormColumn>
            <FormColumn cols="1" class="last mt-0 d-flex align-items-center">
                {#if siblingDetails.length > 1}
                    <div class="confirmation-hide">
                        <button on:click|preventDefault={() => deleteRow(i)} class="delete " title="Delete" aria-label="Delete">
                                <i class="fas fa-trash"></i>
                        </button>
                    </div>
                {/if}
            </FormColumn>
        </FormRow>
        {/if}
    {/each}

    <div class="confirmation-hide" style="margin-top: 20px;">
        <AddButton on:add={addNewRow}>Add another sibling</AddButton>
    </div>
</div>
    
<style>
    .delete {
        border: none;
        outline: none;
        background-color: transparent;
        font-size: 1.1rem;
        font-weight: 700;
        color: var(--color-primary);
        margin-top: 10px;
    }
</style>